import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavigationComponent } from './navigation.component';
import { PipesModule } from '../pipes/pipes.module';

@NgModule({
  declarations: [NavigationComponent],
  imports: [
    CommonModule, PipesModule
  ],
  exports:[NavigationComponent]
})
export class NavigationModule { }
